<template>
  <SliderWithIndicator>
    <div class="px-5 flex flex-col gap-1">
      <div class="flex gap-2">
        <NavMainBarCategory
          v-for="category in firstHalf"
          :key="category.id"
          :current-item="category"
        />
      </div>
      <div class="flex gap-2">
        <NavMainBarCategory
          v-for="category in secondHalf"
          :key="category.id"
          :current-item="category"
        />
        <NavMainBarOnSale
          :class="{'hidden': hideOnSaleLink}"
        />
      </div>
    </div>
  </SliderWithIndicator>
</template>

<script lang="ts">

import type { Category } from '~~/types/commercetools';

export default defineComponent({
  name: 'NavMainBarMobile',

  props: {
    categories: {
      type: Array as PropType<Category[]>,
      default: () => {

        return [];
      
      },
    },
    hideOnSaleLink: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {

    const middleOfCategories = computed<number>(() => {

      return Math.ceil(props.categories.length / 2);
    
    });

    const firstHalf = computed<Category[]>(() => {

      return props.categories.slice(
        0, middleOfCategories.value,
      );
    
    });
    const secondHalf = computed<Category[]>(() => {

      return props.categories.slice(
        middleOfCategories.value,
      );
    
    });

    return {
      firstHalf,
      secondHalf,
    };
  
  },
});

</script>
